import CONSTANTS from '../constants'
import { downloadFile, getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'

export const getSessionDetails = (promoObj) => (dispatch) => {
  // if(pageload) {
  //   dispatch({ type: CONSTANTS.SESSION_EVENT_REQUEST })
  // }
  dispatch(addEventLog(promoObj, CONSTANTS.APPLY_PROMOCODE_REQUEST))
  dispatch({ type: CONSTANTS.APPLY_PROMOCODE_REQUEST })
  return postRequest(APICONFIG.getSessionDetails, promoObj).then((res) => {
    let resObject = { ...promoObj, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.APPLY_PROMOCODE_SUCCESS))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_SUCCESS, data: res, 'promocode': promoObj.promo ? true : false })
    localStorage.setItem('paymentSession', JSON.stringify(res?.data))
    return { 'data': res?.data, 'promocode': promoObj.promo ? true : false }
  }).catch((err) => {
    let errObject = { ...promoObj, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.APPLY_PROMOCODE_FAILURE))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_FAILURE })
    // if(pageload) {
    //   dispatch({ type: CONSTANTS.SESSION_EVENT_COMPLETE })
    // }
    return err
  })
}
export const getDefaultSession = (defaultSession) => (dispatch) => {
  dispatch(addEventLog(defaultSession, CONSTANTS.APPLY_PROMOCODE_REQUEST))
  dispatch({ type: CONSTANTS.APPLY_PROMOCODE_REQUEST })
  return postRequest(APICONFIG.getSessionDetails, defaultSession).then((res) => {
    let resObject = { ...defaultSession, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.APPLY_PROMOCODE_SUCCESS))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_SUCCESS, data: res })
    localStorage.setItem('paymentSession', JSON.stringify(res?.data))
    return { 'data': res?.data }
  }).catch((err) => {
    let errObject = { ...defaultSession, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.APPLY_PROMOCODE_FAILURE))
    dispatch({ type: CONSTANTS.APPLY_PROMOCODE_FAILURE })
    return err
  })
}

//UPDATE PROMOCODE USAGE DETAILS
export const updatePromoCodeUsageDetails = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.GET_PROMOCODE_USAGE_REQUEST))
  dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_REQUEST })
  return postRequest(APICONFIG.getPromoCodeUsage, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.GET_PROMOCODE_USAGE_SUCCESS))
    dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.GET_PROMOCODE_USAGE_FAILURE))
    dispatch({ type: CONSTANTS.GET_PROMOCODE_USAGE_FAILURE })
  })
}

// Calls the API to booking before payment
export const saveBookingBeforePayment = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.BEFORE_PAYMENT_INITIAL_REQUEST))
  dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_REQUEST })
  return postRequest(APICONFIG.saveBookingBeforePaymentUrl, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.BEFORE_PAYMENT_INITIAL_SUCCESS))
    dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.BEFORE_PAYMENT_INITIAL_FAILURE))
    dispatch({ type: CONSTANTS.BEFORE_PAYMENT_INITIAL_FAILURE })
    return err
  })
}


// Calls the API to booking before payment
export const saveBookingAfterPayment = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.AFTER_PAYMENT_INITIAL_REQUEST))
  dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_REQUEST })
  return postRequest(APICONFIG.saveBookingafterPaymentUrl, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.AFTER_PAYMENT_INITIAL_SUCCESS))
    dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.AFTER_PAYMENT_INITIAL_FAILURE))
    dispatch({ type: CONSTANTS.AFTER_PAYMENT_INITIAL_FAILURE })
    return err
  })
}
export const downloadQrcodeRequest = (postData, pdfName, setPromoLoader) => (dispatch) => {
  dispatch({ type: CONSTANTS.QRCODE_REQUEST })
  let endpoint = `${APICONFIG.downloadQrcodeRequestUrl}/${postData}`
  return downloadFile(endpoint, `${pdfName}.pdf`, setPromoLoader)
}


// new payment gate way API 
export const dynamicPaymentGateByNonce = (postData) => (dispatch) => {
  dispatch(addEventLog(postData, CONSTANTS.NONCE_TYPE_PAYMENT_REQUEST))
  dispatch({ type: CONSTANTS.NONCE_TYPE_PAYMENT_REQUEST })
  return postRequest(APICONFIG.noncePaymentGateway, postData).then((res) => {
    let resObject = { ...postData, ...res }
    dispatch(addEventLog(resObject, CONSTANTS.NONCE_TYPE_PAYMENT_SUCCESS))
    dispatch({ type: CONSTANTS.NONCE_TYPE_PAYMENT_SUCCESS, data: res })
    return res
  }).catch((err) => {
    let errObject = { ...postData, ...err }
    dispatch(addEventLog(errObject, CONSTANTS.NONCE_TYPE_PAYMENT_FAILURE))
    dispatch({ type: CONSTANTS.NONCE_TYPE_PAYMENT_FAILURE })
    return err
  })
}


// Calls the API to get Facility Initials
export const getCardDataList = () => (dispatch) => {
  dispatch({ type: CONSTANTS.GET_CARD_LIST_REQUEST })
  let endpoint = `${APICONFIG.getCardDataUrl}`    
  return getRequest(endpoint).then((res) => {
      dispatch({ type: CONSTANTS.GET_CARD_LIST_SUCCESS, data: res?.data?.payments })
      return res
  }).catch(() => {
      dispatch({ type: CONSTANTS.GET_CARD_LIST_FAILURE })
  })
}
